/* Datenrechner für /pages/data-calculator.
   Lag zuvor als Inline-Skript in der Section und wurde vom Browser nie ausgeführt: das Theme
   setzt #MainContent nach dem Parsen neu ein, und per innerHTML eingefügte Inline-Skripte
   laufen laut HTML-Spezifikation nicht. Als externes, verzögertes Skript ist das kein Problem.
   Die Initialisierung ist idempotent: Sie bricht ab, wenn der Rechner schon aufgebaut ist.

   9.10.2026 (Crawler-Sicht): Zwei Wege.
   1. Neue Section (Kennzeichen data-as-calc="2" am Rechner): Der Server liefert den Rechner fertig
      und in der Seitensprache aus (Kategorien, Regler, Beispielrechnung). Das Skript baut nichts mehr,
      es übernimmt die vorhandenen Regler und rechnet. Alle Texte, die sich beim Bedienen ändern
      (Stunden, Tage, Tarifname, Knopf), kommen aus dem JSON-Block #acI18n, den der Server je Sprache
      mitliefert. Im Skript steht kein Kundentext mehr.
   2. Alte Section (ohne Kennzeichen): unverändert der bisherige Aufbau, damit die Reihenfolge beim
      Hochladen egal ist. */
(function () {
  var PLAN_DAYS = [1, 3, 5, 7, 10, 14, 20, 30];
  function bestPlan(d) { for (var i = 0; i < PLAN_DAYS.length; i++) { if (d <= PLAN_DAYS[i]) return PLAN_DAYS[i]; } return 30; }

  function animNum(el, target, dec, dez) {
    // Endwert zuerst schreiben: Er bleibt stehen, wenn requestAnimationFrame nicht feuert
    // (inaktiver Tab, Hintergrundfenster). Die Animation laeuft nur darueber und wird
    // NICHT synchron gestartet, sonst ueberschriebe ihr erster Schritt den Endwert
    // sofort wieder mit dem Startwert.
    // 9.10.2026 (Handy-Pruefung): dez ist das Dezimalzeichen der Seitensprache (aus #acI18n, Weg 1). Auf Deutsch
    // standen die GB-Werte mit Punkt neben Stundenwerten mit Komma. Ohne Angabe bleibt es beim Punkt.
    if (!el) return;
    var fmt = function (v) { var z = v.toFixed(dec); return (dez && dez !== '.') ? z.replace('.', dez) : z; };
    var s = parseFloat(String(el.textContent).replace(',', '.')) || 0, t0 = performance.now(), dur = 380;
    var ziel = fmt(target);
    el.setAttribute('data-ziel', ziel);
    el.textContent = ziel;
    if (fmt(s) === ziel) return;                         // nichts zu zeigen, kein Zucken
    if (typeof requestAnimationFrame !== 'function') return;
    requestAnimationFrame(function step(now) {
      if (el.getAttribute('data-ziel') !== ziel) return; // ein neuerer Wert laeuft schon
      var p = Math.min((now - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(s + (target - s) * e);
      if (p < 1) requestAnimationFrame(step);
    });
    // Bricht der Browser die Animation mittendrin ab (Tab wandert in den Hintergrund), stuende sonst
    // ein Zwischenwert da. Ein Zeitgeber stellt den Endwert in jedem Fall her.
    setTimeout(function () {
      if (el.getAttribute('data-ziel') === ziel && el.textContent !== ziel) el.textContent = ziel;
    }, dur + 80);
  }

  function setzeText(el, s) {
    if (!el || s === undefined || s === null) return;
    if (el.textContent !== s) el.textContent = s;
  }

  /* ---------- Weg 1: Rechner kommt fertig vom Server ---------- */
  function uebernehmen(wurzel) {
    if (wurzel.__asCalc) return;                 // dieser Knoten ist schon verdrahtet
    var I = null;
    try {
      var roh = document.getElementById('acI18n');
      if (roh) I = JSON.parse(roh.textContent);
    } catch (e) { I = null; }
    // Fehlt der Textblock, rechnet der Rechner trotzdem. Die vom Server gelieferten Texte bleiben dann stehen.
    I = I || {};
    I.h = I.h || {}; I.days = I.days || []; I.plans = I.plans || {}; I.cta = I.cta || {};
    var DEZ = (typeof I.dez === 'string' && I.dez.length === 1) ? I.dez : '.';   // Dezimalzeichen der Seitensprache

    var ts = document.getElementById('acTripSlider');
    var zeilen = wurzel.querySelectorAll('#acCats .ac__cat[data-cat]');
    if (!ts || !zeilen.length) return;
    wurzel.__asCalc = true;
    wurzel.setAttribute('data-as-bereit', '1');

    var rtl = wurzel.getAttribute('dir') === 'rtl';
    var TRIP_FARBE = '#00C8E0';
    var CATS = [];
    for (var i = 0; i < zeilen.length; i++) {
      var z = zeilen[i];
      CATS.push({
        id: z.getAttribute('data-cat'),
        mb: parseFloat(z.getAttribute('data-mb')) || 0,
        color: z.getAttribute('data-color') || TRIP_FARBE,
        def: parseFloat(z.getAttribute('data-def')) || 0,
        regler: z.querySelector('input[type="range"]'),
        wert: z.querySelector('.ac__cat-val')
      });
    }
    var segs = wurzel.querySelectorAll('#acBar .ac__bar-seg');
    var elDaily = document.getElementById('acDaily');
    var elTotal = document.getElementById('acTotal');
    var elPlan = document.getElementById('acPlanName');
    var elCta = document.getElementById('acCta');
    var elTrip = document.getElementById('acTripDays');
    var elTripUnit = document.getElementById('acTripUnit');
    var tripDef = parseInt(ts.getAttribute('value'), 10) || 7;

    function fmtH(h) { return I.h[String(h)]; }
    function fmtTage(d) { return I.days[d] || undefined; }
    function sliderBg(el, color) {
      var min = parseFloat(el.min), max = parseFloat(el.max);
      var pct = ((parseFloat(el.value) - min) / (max - min)) * 100;
      el.style.background = 'linear-gradient(' + (rtl ? 'to left' : 'to right') + ',' + color + ' ' + pct + '%,rgba(255,255,255,0.08) ' + pct + '%)';
    }
    function stunden(c) { var v = c.regler ? parseFloat(c.regler.value) : c.def; return isNaN(v) ? c.def : v; }
    function tage() { var v = parseInt(ts.value, 10); return isNaN(v) ? tripDef : v; }

    function update() {
      var mb = 0, k;
      for (k = 0; k < CATS.length; k++) mb += stunden(CATS[k]) * CATS[k].mb;
      var tripDays = tage();
      var daily = mb / 1024, total = daily * tripDays;
      animNum(elDaily, daily, 1, DEZ);
      animNum(elTotal, total, 1, DEZ);
      for (k = 0; k < CATS.length; k++) {
        var c = CATS[k], h = stunden(c);
        if (segs[k]) segs[k].style.width = (mb > 0 ? (h * c.mb / mb * 100) : 0) + '%';
        setzeText(c.wert, fmtH(h));
        if (c.regler) { sliderBg(c.regler, c.color); if (fmtH(h) !== undefined) c.regler.setAttribute('aria-valuetext', fmtH(h)); }
      }
      var plan = bestPlan(tripDays);
      setzeText(elPlan, I.plans[String(plan)]);
      setzeText(elCta, I.cta[String(plan)]);
      // Tagesangabe steht ganz im ersten Feld (in manchen Sprachen ohne Ziffer oder mit der Ziffer hinten)
      if (fmtTage(tripDays) !== undefined) {
        setzeText(elTrip, fmtTage(tripDays));
        setzeText(elTripUnit, '');
        ts.setAttribute('aria-valuetext', fmtTage(tripDays));
      } else {
        setzeText(elTrip, String(tripDays));
      }
      sliderBg(ts, TRIP_FARBE);
    }

    for (var j = 0; j < CATS.length; j++) {
      if (CATS[j].regler) CATS[j].regler.addEventListener('input', update);
    }
    ts.addEventListener('input', update);
    var reset = document.getElementById('acReset');
    if (reset) reset.addEventListener('click', function () {
      for (var k = 0; k < CATS.length; k++) { if (CATS[k].regler) CATS[k].regler.value = CATS[k].def; }
      ts.value = tripDef;
      update();
    });
    // Der Browser kann Reglerstände wiederherstellen (Zurück, Neu laden): einmal nachrechnen.
    update();
  }

  /* ---------- Weg 2: bisheriger Aufbau für die alte Section ---------- */
  function aufbauenAlt(wurzel) {
    if (wurzel.dataset.asBereit === '1') return;   // schon aufgebaut
    var cats = document.getElementById('acCats');
    if (!cats) return;
    wurzel.dataset.asBereit = '1';

    (function(){
      var CATS=[
        {id:'social',label:'Social Media',    apps:'Instagram, TikTok, X, WhatsApp', mb:150,icon:'📱',color:'#00C8E0',def:2,max:8},
        {id:'stream',label:'Video Streaming', apps:'YouTube, Netflix, Disney+',       mb:700,icon:'🎬',color:'#4B7BE8',def:1,max:6},
        {id:'calls', label:'Video Calls',     apps:'Zoom, FaceTime, Google Meet',     mb:500,icon:'📹',color:'#9E6DF2',def:0,max:6},
        {id:'maps',  label:'Navigation',      apps:'Google Maps, Waze, Uber',         mb:50, icon:'🗺',color:'#10B981',def:1,max:6},
        {id:'music', label:'Music & Podcasts',apps:'Spotify, Apple Music, Podcasts',  mb:60, icon:'🎵',color:'#F59E0B',def:2,max:8},
        {id:'msg',   label:'Messaging',       apps:'WhatsApp, Telegram, Gmail',       mb:20, icon:'💬',color:'#EC4899',def:3,max:8}
      ];
      var hrs={};
      CATS.forEach(function(c){hrs[c.id]=c.def;});
      var tripDays=7;

      function fmtH(h){if(h===0)return'Off';if(h===0.5)return'30 min';if(h===1)return'1 hour';return h+' hrs';}
      function sliderBg(el,color){
        var pct=((parseFloat(el.value)-parseFloat(el.min))/(parseFloat(el.max)-parseFloat(el.min)))*100;
        el.style.background='linear-gradient(to right,'+color+' '+pct+'%,rgba(255,255,255,0.08) '+pct+'%)';
      }
      function update(){
        var mb=0;
        CATS.forEach(function(c){mb+=hrs[c.id]*c.mb;});
        var daily=mb/1024,total=daily*tripDays;
        animNum(document.getElementById('acDaily'),daily,1);
        animNum(document.getElementById('acTotal'),total,1);
        var bar=document.getElementById('acBar');
        bar.innerHTML='';
        CATS.forEach(function(c){
          var seg=document.createElement('div');
          seg.className='ac__bar-seg';
          seg.style.width=(mb>0?(hrs[c.id]*c.mb/mb*100):0)+'%';
          seg.style.background=c.color;
          bar.appendChild(seg);
        });
        var plan=bestPlan(tripDays);
        document.getElementById('acPlanName').textContent=plan+'-Day Unlimited eSIM';
        document.getElementById('acCtaDays').textContent=plan;
        document.getElementById('acTripDays').textContent=tripDays;
      }
      function buildCats(){
        var wrap=document.getElementById('acCats');
        CATS.forEach(function(c){
          var div=document.createElement('div');
          div.className='ac__cat';
          div.innerHTML='<div class="ac__cat-icon" style="background:'+c.color+'18;">'+c.icon+'</div>'+
            '<div><div class="ac__cat-name">'+c.label+'</div><div class="ac__cat-apps">'+c.apps+'</div></div>'+
            '<div class="ac__cat-ctrl"><div class="ac__cat-val" id="v_'+c.id+'" style="color:'+c.color+'">'+fmtH(c.def)+'</div>'+
            '<input type="range" class="ac__range" id="s_'+c.id+'" min="0" max="'+c.max+'" step="0.5" value="'+c.def+'"></div>';
          wrap.appendChild(div);
          var sl=document.getElementById('s_'+c.id);
          sliderBg(sl,c.color);
          sl.addEventListener('input',function(){
            hrs[c.id]=parseFloat(this.value);
            document.getElementById('v_'+c.id).textContent=fmtH(hrs[c.id]);
            sliderBg(this,c.color);update();
          });
        });
        var leg=document.getElementById('acLegend');
        CATS.forEach(function(c){
          var li=document.createElement('div');
          li.className='ac__legend-item';
          li.innerHTML='<div class="ac__legend-dot" style="background:'+c.color+'"></div>'+c.label;
          leg.appendChild(li);
        });
      }
      var ts=document.getElementById('acTripSlider');
      sliderBg(ts,'#00C8E0');
      ts.addEventListener('input',function(){tripDays=parseInt(this.value);sliderBg(this,'#00C8E0');update();});
      document.getElementById('acReset').addEventListener('click',function(){
        CATS.forEach(function(c){
          hrs[c.id]=c.def;
          var s=document.getElementById('s_'+c.id);if(s){s.value=c.def;sliderBg(s,c.color);}
          var v=document.getElementById('v_'+c.id);if(v)v.textContent=fmtH(c.def);
        });
        tripDays=7;ts.value=7;sliderBg(ts,'#00C8E0');update();
      });
      buildCats();update();
    })();
  }

  function aufbauen() {
    var wurzel = document.getElementById('aeroCalc');
    if (!wurzel) return;                      // Rechner nicht auf dieser Seite
    if (wurzel.getAttribute('data-as-calc') === '2') uebernehmen(wurzel);
    else aufbauenAlt(wurzel);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', aufbauen);
  else aufbauen();
  // Theme-Editor und dynamisch nachgeladene Bereiche
  document.addEventListener('shopify:section:load', aufbauen);
  // Letzte Absicherung: falls das Theme den Bereich später ersetzt
  window.addEventListener('pageshow', aufbauen);
})();
